import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { addUniversalFilteringUpdateApp } from '../actions/universalupdates'
import { fetchMachines } from '../actions/machines'


class UniversalUpdateFilteringAppAddForm extends React.Component {
  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    this.props.fetchMachines()
  }

  submit(values) {
    const { arguments: url, ...rest } = values

    const selectedMachineIds = Object.entries(rest)
      .filter(([key, value]) => key.startsWith('machine_') && value)
      .map(([key]) => key.replace('machine_', ''))

    return this.props.addUniversalFilteringUpdateApp({ url, machines: selectedMachineIds })
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  renderMachineCheckbox(machine) {
    const isUbuntu = machine.OS === 2
    return (
      <label
        key={machine._id}
        htmlFor={`machine_${machine._id}`}
        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', borderRadius: 8, cursor: 'pointer', transition: 'background 0.12s' }}
        onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
      >
        <Field
          name={`machine_${machine._id}`}
          id={`machine_${machine._id}`}
          component="input"
          type="checkbox"
          style={{ width: 15, height: 15, accentColor: '#1d4ed8', cursor: 'pointer', flexShrink: 0 }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#1e293b' }}>{machine.Serial}</span>
          <span style={{ fontSize: 10, color: '#64748b' }}>
            <i className={`fa-brands ${isUbuntu ? 'fa-ubuntu' : 'fa-raspberry-pi'} mr-1`}></i>
            {isUbuntu ? 'Ubuntu' : 'Raspbian'} · v{machine.Sw_version}
          </span>
        </div>
      </label>
    )
  }

  render() {
    const { error, pristine, submitting, handleSubmit, machines, selectedMachinesMap } = this.props

    const selectedMachines = machines.filter(
      m => selectedMachinesMap && selectedMachinesMap[`machine_${m._id}`]
    )
    const selectedCount = selectedMachines.length

    const machinesByCustomer = machines.reduce((acc, machine) => {
      const customer = machine.Customer?.Fullname || 'Sin Cliente'
      acc[customer] = acc[customer] || []
      acc[customer].push(machine)
      return acc
    }, {})

    return (
      <form onSubmit={handleSubmit(this.submit)}>

        {/* ── Action panel (top) ───────────────── */}
        <div style={{ borderRadius: 10, overflow: 'hidden', border: '2px solid #1d4ed8', boxShadow: '0 4px 20px rgba(29,78,216,0.12)', marginBottom: 24 }}>
          {/* Header */}
          <div style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <i className="fas fa-mobile-alt" style={{ fontSize: 18, color: '#fff' }}></i>
            <div style={{ flex: 1 }}>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>Actualización Selectiva de App</div>
              <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11, marginTop: 2 }}>
                {selectedCount === 0
                  ? 'Selecciona máquinas abajo y añade la URL de la APK'
                  : <><strong style={{ color: '#fff' }}>{selectedCount}</strong> máquina{selectedCount !== 1 ? 's' : ''} seleccionada{selectedCount !== 1 ? 's' : ''}</>
                }
              </div>
            </div>
            {selectedCount > 0 && (
              <span style={{ background: 'rgba(255,255,255,0.2)', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 12, fontWeight: 800 }}>
                {selectedCount}
              </span>
            )}
          </div>

          {/* Body */}
          <div style={{ background: '#fff', padding: '18px 20px' }}>
            {/* URL input */}
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6 }}>
                <i className="fas fa-link mr-1"></i> App URL
              </label>
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: 13, pointerEvents: 'none' }}>
                  <i className="fas fa-download"></i>
                </div>
                <Field
                  name="arguments"
                  component="input"
                  type="text"
                  placeholder="https://example.com/app-release.apk"
                  style={{
                    width: '100%', padding: '10px 12px 10px 36px',
                    borderRadius: 8, border: '1.5px solid #e2e8f0',
                    fontSize: 13, fontFamily: 'monospace', color: '#1e293b',
                    background: '#f8fafc', outline: 'none',
                    transition: 'border-color 0.15s, box-shadow 0.15s',
                  }}
                  onFocus={e => { e.target.style.borderColor = '#1d4ed8'; e.target.style.boxShadow = '0 0 0 3px rgba(29,78,216,0.12)' }}
                  onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none' }}
                />
              </div>
            </div>

            {/* Selected machines chips */}
            {selectedCount > 0 && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>
                  Máquinas destino
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {selectedMachines.map(m => (
                    <span
                      key={m._id}
                      style={{ background: '#dbeafe', color: '#1e40af', borderRadius: 8, padding: '4px 10px', fontSize: 11, fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 6, border: '1px solid #bfdbfe' }}
                    >
                      <i className={`fa-brands ${m.OS === 2 ? 'fa-ubuntu' : 'fa-raspberry-pi'}`} style={{ fontSize: 11 }}></i>
                      <span>{m.Serial}</span>
                      <span style={{ fontWeight: 400, color: '#3b82f6', fontSize: 10 }}>v{m.Sw_version}</span>
                    </span>
                  ))}
                </div>
              </div>
            )}

            {error && <div className="alert alert-danger mb-3">{error}</div>}

            {/* Execute button */}
            <button
              type="submit"
              disabled={pristine || submitting || selectedCount === 0}
              style={{
                width: '100%', padding: '11px 0', borderRadius: 8, border: 'none',
                background: selectedCount > 0 ? 'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)' : '#e2e8f0',
                color: selectedCount > 0 ? '#fff' : '#94a3b8',
                fontWeight: 700, fontSize: 14, cursor: selectedCount > 0 ? 'pointer' : 'not-allowed',
                transition: 'all 0.15s'
              }}
            >
              <i className="fas fa-bolt mr-2"></i>
              {submitting ? 'Ejecutando...' : `Ejecutar en ${selectedCount} máquina${selectedCount !== 1 ? 's' : ''}`}
            </button>
          </div>
        </div>

        {/* ── Machine selector (bottom) ────────── */}
        <div style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
          {/* Card header */}
          <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <i className="fas fa-server" style={{ color: '#fff', fontSize: 14, opacity: 0.9 }}></i>
            <span style={{ color: '#fff', fontWeight: 800, fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>Seleccionar máquinas</span>
            {Object.keys(machinesByCustomer).length > 0 && (
              <span style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.15)', color: '#fff', borderRadius: 20, padding: '1px 8px', fontSize: 10, fontWeight: 700 }}>
                {machines.length} máquinas · {Object.keys(machinesByCustomer).length} clientes
              </span>
            )}
          </div>

          {/* Card body */}
          <div style={{ background: '#f8fafc', padding: 16 }}>
            {Object.keys(machinesByCustomer).length === 0 ? (
              <div style={{ color: '#94a3b8', fontSize: 13, padding: '16px 0', textAlign: 'center' }}>
                <i className="fas fa-spinner fa-spin mr-2"></i>Cargando máquinas...</div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
                {Object.entries(machinesByCustomer)
                  .sort(([a], [b]) => a.localeCompare(b))
                  .map(([customer, customerMachines]) => (
                    <div
                      key={customer}
                      style={{ borderRadius: 10, border: '1px solid #e2e8f0', overflow: 'hidden', background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}
                    >
                      <div style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)', padding: '8px 12px', fontSize: 11, fontWeight: 800, color: '#fff', textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 6 }}>
                        <i className="fas fa-building" style={{ fontSize: 10, opacity: 0.8 }}></i>
                        {customer}
                      </div>
                      <div style={{ padding: '6px 2px' }}>
                        {customerMachines.map(machine => this.renderMachineCheckbox(machine))}
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>

      </form>
    )
  }
}

// Redux Form wrapper
UniversalUpdateFilteringAppAddForm = reduxForm({
  form: 'UniversalUpdateFilteringAppAddForm',
})(UniversalUpdateFilteringAppAddForm)

// Map state from Redux
const selector = formValueSelector('UniversalUpdateFilteringAppAddForm')

const mapStateToProps = (state) => {
  const machines = state.machines.machines || []

  const machineFieldNames = machines.map(m => `machine_${m._id}`)
  const selectedMachinesMap = machineFieldNames.length
    ? selector(state, ...machineFieldNames)
    : {}

  return {
    machines,
    selectedMachinesMap,
  }
}

// Map dispatch actions
const mapDispatchToProps = (dispatch) => ({
  addUniversalFilteringUpdateApp: bindActionCreators(addUniversalFilteringUpdateApp, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
})

// Connect Redux and export
export default connect(mapStateToProps, mapDispatchToProps)(UniversalUpdateFilteringAppAddForm)
